"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTitle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const material_1 = require("@mui/material");
const colors_1 = require("../../../styles/colors");
const Typo_1 = require("../../atoms/Typo/Typo");
const styled_1 = __importDefault(require("@emotion/styled"));
const LeftBar = styled_1.default.div `
  width: 8px;
  height: 32px;
  background: ${colors_1.$primaryNavy} 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-right: 8px;
`;
const SectionTitle = (props) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "row", alignItems: props.description ? 'start' : 'center' }, { children: [(0, jsx_runtime_1.jsx)(LeftBar, {}), (0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "column" }, { children: [(0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ color: colors_1.$primaryNavy, variant: "sectionTitle" }, { children: props.title })), props.description && ((0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ color: colors_1.$grey50, variant: "sectionTitleDescription" }, { children: props.description })))] }))] })));
};
exports.SectionTitle = SectionTitle;
